import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FranchiseProduct } from '../campaign.type';

export interface FranchiseProductState {
  products: FranchiseProduct[];
  /** Set on success only, so the picker never prunes against a foreign catalogue. */
  loadedFranchiseId?: string;
  /** Set when a load starts, success or not, so a failure is not retried forever. */
  requestedFranchiseId?: string;
  isLoading: boolean;
  hasError: boolean;
}

const initialState: FranchiseProductState = {
  products: [],
  isLoading: false,
  hasError: false,
};

export const { actions, reducer } = createSlice({
  name: 'franchiseProducts',
  initialState,
  reducers: {
    // The franchise is stored alongside the catalogue so switching store owner or
    // franchise cannot leave the picker showing another franchise's products.
    setFranchiseProducts: (state, action: PayloadAction<{ franchiseId: string; products: FranchiseProduct[] }>) => {
      state.products = action.payload.products;
      state.loadedFranchiseId = action.payload.franchiseId;
      state.hasError = false;
    },
    // Records the attempt before it is made. Without it a failing load leaves
    // loadedFranchiseId unset, the effect sees the catalogue as still missing, and
    // fires again -- which is how one 422 became a hundred.
    startFranchiseProductsLoad: (state, action: PayloadAction<string>) => {
      state.requestedFranchiseId = action.payload;
      state.isLoading = true;
    },
    setFranchiseProductsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setFranchiseProductsError: (state, action: PayloadAction<boolean>) => {
      state.hasError = action.payload;
      state.products = [];
    },
  },
});
